
define('text!templates/parts/modal/gallery.html',[],function () { return '<div class="gallery-image">\n    <img class="" data-bind="attr:{src:imageUrl}">\n</div>';});

